export default __webpack_public_path__ + "static/media/hyperlinkIcon.327a67be.svg";